<template>
  <v-dialog :persistent="true" max-width="800px" v-model="inDialog">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title style="padding-left: 10px">
          {{ $t(formName)}}
        </v-toolbar-title>
      </v-toolbar>
      <v-btn
          @click="onCancel"
          icon
          style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
      >
        <v-icon>cancel</v-icon>
      </v-btn>
      <v-form @keyup.enter.native="onSave" id="createForm" lazy-validation ref="createForm" v-model="formValid">
        <v-layout wrap>
          <v-flex style="padding: 10px" xs12>
            <v-text-field :data-vv-as="$t('lang.groups.groupName')" :error-messages="errors.first('groupName')"
                          :label="$t('lang.groups.groupName')"
                          name="groupName"
                          v-model="item['groupName']"
                          v-validate="'required'"
            ></v-text-field>

          </v-flex>
          <v-flex style="padding: 10px" xs12>
            <v-autocomplete :data-vv-as="$t('lang.groups.parentId')"
                      :error-messages="errors.first('parentId')"
                      :items="groups"
                      :label="$t('lang.groups.parentId')"
                      item-text="groupName"
                      item-value="groupId"
                      name="parentId"
                      v-model="item['parentId']"
                      v-validate=""
            />
          </v-flex>
        </v-layout>
      </v-form>
      <div style="text-align: right">
        <v-btn @click="onSave" color="primary">
          <v-icon dark left>save</v-icon>
          {{$t('lang.common.save')}}
        </v-btn>
        <v-btn @click="onCancel" color="error">
          <v-icon dark left>cancel</v-icon>
          {{$t('lang.common.cancel')}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from "axios";
  import {message} from "@/shared/message";

  export default {
    name: 'group-create',
    components: {},
    inheritAttrs: true,
    props: {
      propsItem: {
        type: Object,
        default: null,
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
    },
    data: () => {
      return {
        formName: "Cập nhật đơn vị",
        formValid: false,
        item: {
          status: 1,
        },
        model: {},
        customerTypes: [],
        countrys: [],
        languages: [],
        manageIds: [],
        groups: [],
        inDialog: false,
      }
    },
    watch: {
      propsItem: {
        handler(value) {
          //console.log(value);
          if (value !== null) {
            this.item = Object.assign({}, value)
          } else {
            this.resetFrom();
          }
        },
        deep: true,
      },
      cDialog(value) {
        this.inDialog = value;
      },
      inDialog(value) {
        if (!value) {
          this.$emit("closeDialog", "");
        }
      },
    },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
      },
      onSave: function () {
        this.$validator.validate().then(
          valid => {
            if (!valid) {
              message.error(this.$t('lang.common.validate_fail'));
              return;
            }
            axios.post(process.env.VUE_APP_API_URL + "/groups/save", this.item).then(data => {
              if (data.success) {
                message.success(this.$t("lang.common.save_success"));
                this.$emit("save", this.item);
                this.onCancel();
              } else {
                message.error(this.$t(data.description));
              }
            }, error => {
              message.error(error);
            });

          }
        )
      },
    },

    created() {
      axios.post(process.env.VUE_APP_API_URL + "/groups/search?page=-1&pageSize=-1", {}).then(
          data => {
            this.groups = data.items;
          }
      )

    },


  }
</script>
